import React, { useState } from "react";
import { forgotPassword } from "../../services/auth";
import "./css/login.css";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [error, setError] = useState(null);

  const submit = async () => {
    setError(null);
    try {
      await forgotPassword(email);
      setDone(true);
    } catch (e) {
      setError("Något gick fel. Försök igen.");
    }
  };

  if (done) {
    return (
      <div className="login-wrapper">
        <div className="login-card">
          <h1>Återställ lösenord</h1>
          <p>Om kontot finns har ett mail skickats.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="login-wrapper">
      <div className="login-card">
        <h1>Återställ lösenord</h1>

        <div className="login-field">
          <label>E-post</label>
          <input value={email} onChange={(e) => setEmail(e.target.value)} />
        </div>

        {error && <div className="login-error">{error}</div>}

        <button className="login-button" onClick={submit}>
          Skicka återställningslänk
        </button>
      </div>
    </div>
  );
}
